var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPictureChairAndLamp = function SvgPictureChairAndLamp(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 130,
    height: 80,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#picture-chair-and-lamp_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#D4EFFC",
    d: "M53 0H17v44h36z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#55A8E1",
    d: "M107 16h-2v9h2z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#55A8E1",
    strokeMiterlimit: 10,
    d: "M48 6H22v33h26z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0075C9",
    d: "M101 12h-1v62h1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0075C9",
    d: "M112 18H89l5.18-18h12.64zM39.13 80c-.261 0-.523-.314-.628-.838-.053-.315 0-.63 0-.944.105-1.678.21-3.303.367-4.98.052-.84.314-3.932.314-3.932.892 0 1.992.052 2.884.052a608 608 0 0 1-2.255 9.384c-.104.42-.21.839-.419 1.049 0 .157-.105.21-.262.21M54.492 80c-.262 0-.524-.314-.629-.838-.052-.315 0-.63 0-.944.105-1.678.21-3.303.367-4.98.053-.84.315-3.932.315-3.932.89 0 1.992.052 2.883.052a609 609 0 0 1-2.254 9.384c-.105.42-.21.839-.42 1.049-.052.157-.157.21-.262.21M101.254 80c.262 0 .524-.314.629-.838.053-.315 0-.63 0-.944a157 157 0 0 0-.367-4.98c-.052-.84-.314-3.932-.314-3.932-.891 0-1.992.052-2.884.052a605 605 0 0 0 2.255 9.384c.104.42.209.839.419 1.049 0 .157.157.21.262.21M85.895 80c.262 0 .524-.314.629-.838.052-.315 0-.63 0-.944-.105-1.678-.21-3.303-.367-4.98-.052-.84-.315-3.932-.315-3.932-.89 0-1.992.052-2.883.052a609 609 0 0 0 2.254 9.384c.105.42.21.839.42 1.049.052.157.157.21.262.21"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0454A3",
    d: "M87.52 53.893h-7.498c-.471 0 .84-.42.84-.892l-.63-20.288c.052-.996.891-1.782 1.835-1.782h.786c.892 0 1.678.629 1.835 1.52l3.67 20.34c.105.578-.262 1.102-.839 1.102"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#55A8E1",
    d: "M99.893 72.084H81.177c-2.202 0-2.097-1.993-1.73-4.142l1.782-19.66c.315-1.677 1.73-2.883 3.46-2.883h20.132z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AADBF9",
    d: "m43.063 56.147-4.561-25.216h44.666c.734 0 1.31.524 1.468 1.205l4.351 23.749z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#55A8E1",
    d: "M38.712 72.084H57.27l-3.565-26.685H35.2c-2.36 0-4.142 2.15-3.723 4.456l3.513 19.083a3.77 3.77 0 0 0 3.722 3.146"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AADBF9",
    d: "M104.924 45.453c-1.835-.315-3.513.996-3.88 2.83l-2.62 14.523a2.426 2.426 0 0 1-2.412 1.992H61.83c-1.154 0-2.202-.84-2.412-1.992l-2.621-14.522a3.454 3.454 0 0 0-3.88-2.831 3.4 3.4 0 0 0-2.778 3.932l3.617 19.974c.315 1.677 1.783 2.83 3.46 2.726h43.618c1.573-.053 2.936-1.154 3.198-2.779l3.617-19.974c.367-1.782-.839-3.565-2.726-3.879"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#55A8E1",
    d: "M43.431 53.892h-7.444a.92.92 0 0 1-.891-.891l1.048-20.236c.053-.996.891-1.783 1.835-1.783h.786c.892 0 1.678.63 1.835 1.52l3.618 20.342c.157.524-.263 1.048-.787 1.048"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AADBF9",
    d: "M58.162 55.675H96.38a2.573 2.573 0 0 1 2.569 2.569v3.827a2.573 2.573 0 0 1-2.57 2.568H62.042s-2.411.734-2.883-3.512-.996-5.452-.996-5.452"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#55A8E1",
    d: "M58.476 42.412a1.153 1.153 0 1 0 0-2.307 1.153 1.153 0 0 0 0 2.307M70.429 42.412a1.153 1.153 0 1 0 0-2.307 1.153 1.153 0 0 0 0 2.307"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#55A8E1",
    strokeMiterlimit: 10,
    d: "m100.625 49.542-2.202 13.263a2.426 2.426 0 0 1-2.411 1.992H61.83c-1.154 0-2.202-.839-2.412-1.992l-2.621-14.522a3.454 3.454 0 0 0-3.88-2.83 3.4 3.4 0 0 0-2.778 3.931l2.988 18.297M58.162 55.413h33.552"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#AADBF9",
    strokeMiterlimit: 10,
    d: "M91 16h20"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "picture-chair-and-lamp_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h130v80H0z"
  })))));
};
export default SvgPictureChairAndLamp;